import { render } from "./HomeView.vue?vue&type=template&id=bb0f1a78&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=bb0f1a78&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb0f1a78"]])

export default __exports__